<template>
  <div
    class="flex-1 md:py-10 px-3 w-full md:max-h-screen md:overflow-x-scroll absolute gray-background min-h-screen"
  >
    <router-view />
  </div>
</template>
<script>
import { DOCUMENT_SIGNING_GET_BY_SIGNER } from "@/store/types"
export default {
  data() {
    return {
      id: "",
      token: ""
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.id = id

    if (this.$route.query.t) {
      this.token = this.$route.query.t
    }

    if (!this.token) {
      this.$router.push({ name: "403" })
      return
    }

    if (this.$route.name === "signing") {
      this.$router.push({ name: "signing_document", params: { id }, query: { t: this.token } })
    }

    if (this.$route.name !== "signing_view") {
      this.loadSigning()
    }
  },
  methods: {
    async loadSigning() {
      const { token, id } = this
      try {
        await this.$store.dispatch(DOCUMENT_SIGNING_GET_BY_SIGNER, { id, token })
      } catch (err) {
        if (err.response) {
          if (err.response.status === 403) {
            this.$router.push({ name: "403" })
          }

          if (err.response.status === 409) {
            this.$router.push({ name: "signing_complete", query: { t: token } })
          }
        }
      }
    }
  }
}
</script>
